<template>
  <v-menu offset-y content-class="new-app-menu">
    <template v-slot:activator="{ on, attrs }">
      <button
        v-bind="attrs"
        v-on="on"
        class="new-app-btn"
      >
        Actions
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>
      </button>
    </template>
    <div class="new-app-dropdown">
      <button class="new-app-dropdown__item" @click="addNewApplication()">
        <v-icon size="16" color="var(--app-text-muted)" class="mr-2">mdi-plus-circle-outline</v-icon>
        New Application
      </button>
      <button class="new-app-dropdown__item" @click="addNewBulkApplication(true)" v-if="isDmAdminRolesChild">
        <v-icon size="16" color="var(--app-text-muted)" class="mr-2">mdi-file-upload-outline</v-icon>
        Bulk Upload Application via Excel
      </button>
    </div>
  </v-menu>
</template>

<script>
export default {
  props: {
    isDmAdminRolesChild: Boolean,
  },
  emits: ["addNewApplication", "addNewBulkApplication"],
  methods: {
    addNewApplication() {
      this.$emit("addNewApplication");
    },
    addNewBulkApplication(val) {
      this.$emit("addNewBulkApplication", val);
    },
  },
};
</script>

<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .new-app-btn {
  border: 1px solid var(--app-border);
  background: var(--app-card);
  color: var(--app-text);
}

.dark-mode .new-app-btn:hover {
  background: var(--app-surface);
  border-color: var(--app-border-strong);
}

.dark-mode .new-app-btn svg {
  color: var(--app-text-faint);
}

/* >>> end auto-dark <<< */

.new-app-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #334155;
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}

.new-app-btn:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.new-app-btn svg {
  flex-shrink: 0;
  color: #94a3b8;
}
</style>

<style>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .new-app-menu {
  border: 1px solid var(--app-border) !important;
}

.dark-mode .new-app-dropdown {
  background: var(--app-card);
}

.dark-mode .new-app-dropdown__item {
  color: var(--app-text);
}

.dark-mode .new-app-dropdown__item:hover {
  background: var(--app-accent-soft);
}

/* >>> end auto-dark <<< */

.new-app-menu {
  border-radius: 12px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid #e2e8f0 !important;
  overflow: hidden;
  margin-top: 6px;
}

.new-app-dropdown {
  background: #fff;
  padding: 4px;
  min-width: 220px;
}

.new-app-dropdown__item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 14px;
  border: none;
  background: transparent;
  border-radius: 8px;
  font-family: 'Lato', sans-serif;
  font-size: 0.82rem;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
  transition: all 0.12s ease;
  text-align: left;
}

.new-app-dropdown__item:hover {
  background: #f0f9ff;
  color: #0369a1;
}
</style>
